/*
by zhang.qiang 2017/02/24
 */
"use strict";
angular.module('planningcenterWeiBoDetailModule', [])
    .controller('planningcenterWeiBoDetailCtrl', ['$scope', '$stateParams', '$window', 'trsHttpService', 'modalDialog', function($scope, $stateParams, $window, trsHttpService, modalDialog) {
        initStatus();
        initData();
        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {};
        }
        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }
        /**
         * [requestData 请求数据]
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {
                "serviceid": "globalsen",
                "modelid": "sentimentmapareadetail",
                "typeid": "widget",
                "s_id": $stateParams.SID
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                if (data.length === 0) {
                    modalDialog.alertType('连接超时,请关闭页面稍后再试！', "", "error", false, function() {
                        return;
                    });
                }
                $scope.status = data;
            });
        }
        /**
         * [close 关闭]
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $window.close();
        };
    }]);
